<template>
<MainLayout501 selectMenu="1-1" sideBar="machine" siderMenu="501-1">
    <Tabs v-model="selectTab" type="card" class="custom-tabs">
        <TabPane :label="getTranslation('k001')" name="m1" class="custom-tabpane">
            <RealTime :runningData = "runningData"></RealTime>
        </TabPane>
        <TabPane :label="getTranslation('r010')" name="m2" class="custom-tabpane">
            <IoStatus :runningData = "runningData"></IoStatus>
        </TabPane>
    </Tabs>
</MainLayout501>
</template>

<script>
import MainLayout501 from '@/components/501/MainLayout.vue'
import RealTime from './components/RealTime.vue'
import IoStatus from './components/IoStatus.vue'
import {
    API_URL
} from '@/constants/const'
import {
    mapGetters
} from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
    name: 'RunningIndex',
    components: {
        MainLayout501,RealTime,IoStatus
    },
    data() {
        return {
            runningData: {},
            eventSource: null,
            selectTab:"",
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),  
    },
    watch: {
        '$route.query.mac'(newMac, oldMac) {
            if (newMac !== oldMac) {
                this.closeEventSource()
                this.runningData = {}
                if (newMac) {
                    this.connectSSE(newMac)
                }
            }
        },
        selectTab(newVal) {            
            if(newVal){
                localStorage.setItem('running501.selectTab', newVal);
            }
        }
    },
    mounted() {
        const macId = this.$route.query.mac || ''
        if (macId) {
            this.connectSSE(macId)
        }
    },
    beforeDestroy() {
        this.closeEventSource()
    },
    async created() {
        this.init();
    },
    methods: {  
        init(){
            this.selectTab = localStorage.getItem('running501.selectTab') || 'm1';
        },   
        connectSSE(macId) {
            const url = API_URL['running501Subscribe'] + '?mac=' + macId
            this.eventSource = new EventSource(url)
            this.eventSource.onmessage = (event) => {
                try {
                    const dataObj = JSON.parse(event.data)
                    if (dataObj) {
                        if(dataObj.type == 'RunningOf501'){
                            let data = dataObj.data;
                            for (var i in data) {
                                this.$set(this.runningData, i, data[i])
                            }
                        }
                    }
                } catch (e) {
                    postJsError(e)                    
                }
            }           
        },
        closeEventSource() {
            if (this.eventSource) {
                this.eventSource.close()
                this.eventSource = null
            }
        }
    }
}
</script>